import React, {Component} from "react";
import AuthHelper from "../../../libraries/auth-helper";
import AccessManagement from "../access-management";
import ContentDashboard from "../content-dashboard";
import NotFound from "../not-found";
import {Switch} from "react-router-dom";
import Sidebar from "../sidebar";
import Navbar from "../navbar";
import Accounts from "../accounts";
import AccountDetail from "../accounts/detail";
import Info from "../info";
import Settings from "../settings";
import Tickets from "../tickets";
import Sales from "../sales";
import Fulfillment from "../fulfillment";
import Transactions from "../transactions";
import {PrivateRoute} from "../../../libraries/route-handling";
import {bindActionCreators} from "redux";
import {RootActions} from "../../../shared/root-action";
import {connect} from "react-redux";
import Modules from "../modules";
import PaymentRules from "../payment-rules";
import AdminReports from "../admin-reports";
import Uploads from "../upload";
import {Grid} from "@material-ui/core"

const styleSidebar = {
    zIndex: "550",
    position: "relative",
    //maxWidth: "220px",
    height:window.innerHeight-90,
};

class Dashboard extends Component {
    componentDidMount() {
        if (AuthHelper.isLoggedIn()) {
            let profile = AuthHelper.getProfile();

            let user = JSON.parse(JSON.stringify(profile));
            delete user.role;

            let role = JSON.parse(JSON.stringify(profile.role));
            delete role.permisssions;

            let permissions = JSON.parse(JSON.stringify(profile.role.permissions));

            this.props.setProfile(user);
            this.props.setRole(role);
            this.props.setPermission(permissions);
        } else {
            AuthHelper.logOut();

            this.props.history.push("/login");
        }
    }

    render() {
        return (
            <div>
                <Navbar/>

                <main className="dashboard">
                    
                        <Grid container>
                            <Grid xs={3} sm={2} md={2} lg={2} style={styleSidebar}>
                                <Sidebar/>
                            </Grid>
                            <Grid  xs={9} sm={10} md={10} lg={10}className="content">
                                <Switch>
                                    <PrivateRoute exact path="/" component={ContentDashboard}/>
                                    <PrivateRoute exact path="/accounts" component={Accounts}/>
                                    <PrivateRoute
                                        path="/accounts/detail/:id"
                                        component={AccountDetail}
                                    />
                                    <PrivateRoute path="/tickets" component={Tickets}/>
                                    <PrivateRoute path="/sales" component={Sales}/>
                                    <PrivateRoute path="/fulfillment" component={Fulfillment}/>
                                    <PrivateRoute path="/transactions" component={Transactions}/>
                                    <PrivateRoute path="/uploads" component={Uploads}/>
                                    <PrivateRoute
                                        path="/access-management"
                                        component={AccessManagement}
                                    />
                                    <PrivateRoute path="/settings" component={Settings}/>
                                    <PrivateRoute path="/modules" component={Modules}/>
                                    <PrivateRoute path="/payment-rules" component={PaymentRules}/>
                                    <PrivateRoute path="/reports" component={AdminReports}/>
                                    <PrivateRoute path="/info" component={Info}/>
                                    <PrivateRoute component={NotFound}/>
                                </Switch>
                            </Grid>
                           {/* <div className="col-md px-0" >
                               
                            </div>

                            <div className="col-md dash-content content">
                              
                            </div>*/}
                        </Grid>
                   
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        profile_state: state.profile_state,

        role_state: state.role_state,

        permission_state: state.permission_state,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(RootActions, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
